import React, { useState } from "react";
import contact_img from "../../assets/banner/contact_img.jpg"; // Desktop banner
import api from "../../api/axios";

import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaGlobe,
  FaFacebook,
  FaLinkedin,
  FaYoutube,
  FaInstagram,
  FaCheckCircle,
  FaTimes,
} from "react-icons/fa";
import { FiSend } from "react-icons/fi";

const ContactUs = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
  });

  const mapSrc =
    "https://maps.google.com/maps?q=LilyPond%20Center%2C%203%2C%20R.%20K%20Mission%20Road%2C%20Motijheel%2C%20Dhaka-1000&t=&z=13&ie=UTF8&iwloc=&output=embed";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.post("/api/contact", form);
      setIsSubmitted(true);
      setForm({
        name: "",
        email: "",
        mobile: "",
        subject: "",
        message: "",
      });
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Unable to send your message. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  const closeModal = () => setIsSubmitted(false);

  return (
    <div className="bg-light min-vh-100">
      {/* ===== Desktop / Tablet Banner (Medium & Above Screen-এ দেখাবে) ===== */}
      <div
        className="d-none d-md-block w-100 overflow-hidden"
        style={{ maxHeight: "350px" }}
      >
        <img
          src={contact_img}
          alt="Contact Us Desktop Banner"
          className="w-100 h-100 object-fit-cover"
        />
      </div>

      {/* ===== Mobile Banner (শুধুমাত্র Small Screen / Mobile-এ দেখাবে) ===== */}
      <div
        className="d-block d-md-none w-100 overflow-hidden position-relative"
        style={{ height: "250px" }}
      >
        {/* ব্যাকগ্রাউন্ড ইমেজ */}
        <img
          src={contact_img}
          alt="Contact Us Mobile Banner"
          className="w-100 h-100 object-fit-cover"
          style={{ objectPosition: "center center" }}
        />

        {/* বাম দিকের টেক্সট এবং আইকন ওভারলে */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-start p-4" // 'justify-content-start' বাম দিকে করার জন্য
          style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
        >
          <div className="text-white text-start">
            {" "}
            {/* 'text-start' বাম দিকে অ্যালাইন করার জন্য */}
            {/* কল আইকন (উপরে) */}
            <div className="mb-3">
              <FaPhoneAlt className="display-6" />
            </div>
            {/* মেইন টাইটেল (নিচে) */}
            <h3
              className="fw-bold mb-1 text-uppercase text-white tracking-wide lh-base"
              style={{ maxWidth: "250px" }}
            >
              YOUR CALLS, OUR PRIORITY
            </h3>
          </div>
        </div>
      </div>

      {/* ===== Container Block ===== */}
      <div className="container py-5" style={{ maxWidth: "1440px" }}>
        {/* Header Section */}
        <div className="text-center mb-5">
          <h2 className="fw-bold  display-6 mb-2" style={{ color: "#bd06b3" }}>
            GET <span style={{ color: "#00bfff" }}>IN TOUCH</span>
          </h2>
          <p className="text-muted fs-6 mx-auto" style={{ maxWidth: "650px" }}>
            Have any questions? Reach out to us directly or fill out the form
            below. We are here to help!
          </p>
        </div>

        {/* Row Layout */}
        <div className="row g-4 justify-content-between">
          {/* Left Column - Contact Info */}
          <div className="col-12 col-lg-5">
            <div className="bg-white p-4 p-md-5 rounded-3 shadow-sm h-100">
              <h3
                className="fw-semibold text-dark mb-4 pb-2 border-bottom border-2"
                style={{ borderColor: "#b800ff", display: "inline-block" }}
              >
                Contact Information
              </h3>

              {/* Office Item */}
              <div className="mb-4">
                <div className="d-flex align-items-center mb-1">
                  <FaMapMarkerAlt
                    className="me-2 fs-5"
                    style={{ color: "#b800ff" }}
                  />
                  <h5 className="m-0 fw-semibold text-secondary">Our Office</h5>
                </div>
                <p className="m-0 text-muted lh-base">
                  Suite: 8/A&B, LilyPond Center,
                  <br />
                  3, R. K Mission Road, Motijheel,
                  <br />
                  Dhaka-1000, Bangladesh
                </p>
              </div>

              {/* Email Item */}
              <div className="mb-4">
                <div className="d-flex align-items-center mb-1">
                  <FaEnvelope
                    className="me-2 fs-5"
                    style={{ color: "#b800ff" }}
                  />
                  <h5 className="m-0 fw-semibold text-secondary">Email Us</h5>
                </div>
                <p className="m-0 text-muted">info@iconicgreenland.com</p>
              </div>

              {/* Website Item */}
              <div className="mb-4">
                <div className="d-flex align-items-center mb-1">
                  <FaGlobe className="me-2 fs-5" style={{ color: "#b800ff" }} />
                  <h5 className="m-0 fw-semibold text-secondary">
                    Visit Website
                  </h5>
                </div>
                <p className="m-0 text-muted">iconicgreenland.com</p>
              </div>

              {/* Phone Item */}
              <div className="mb-4">
                <div className="d-flex align-items-center mb-1">
                  <FaPhoneAlt
                    className="me-2 fs-5"
                    style={{ color: "#b800ff" }}
                  />
                  <h5 className="m-0 fw-semibold text-secondary">Call Us</h5>
                </div>
                <p className="m-0 text-muted lh-base">
                  Hotline: 01937-900900
                  <br />
                  Phone: 01803030303
                </p>
              </div>

              {/* Social Links */}
              <div className="mt-4 pt-2">
                <h5 className="fw-semibold mb-3">Follow Us</h5>
                <div className="d-flex gap-2">
                  <a
                    href="https://www.facebook.com/iconicgreenland/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center p-0"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <FaFacebook />
                  </a>
                  <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-info text-white rounded-circle d-flex align-items-center justify-content-center p-0"
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "#0077b5",
                    }}
                  >
                    <FaLinkedin />
                  </a>
                  <a
                    href="https://www.youtube.com/@iconicgreenland"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-danger rounded-circle d-flex align-items-center justify-content-center p-0"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <FaYoutube />
                  </a>
                  <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn rounded-circle text-white d-flex align-items-center justify-content-center p-0"
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "#e4405f",
                    }}
                  >
                    <FaInstagram />
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Form */}
          <div className="col-12 col-lg-7">
            <div className="bg-white p-4 p-md-5 rounded-3 shadow-sm h-100">
              <h3 className="fw-semibold text-dark mb-4">Send a Message</h3>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label fw-semibold text-secondary">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    className="form-control form-control-lg fs-6"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold text-secondary">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    className="form-control form-control-lg fs-6"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold text-secondary">
                    Mobile
                  </label>
                  <input
                    type="tel"
                    name="mobile"
                    value={form.mobile}
                    onChange={handleChange}
                    className="form-control form-control-lg fs-6"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold text-secondary">
                    Subject
                  </label>
                  <input
                    type="text"
                    name="subject"
                    value={form.subject}
                    onChange={handleChange}
                    className="form-control form-control-lg fs-6"
                    required
                  />
                </div>

                <div className="mb-4">
                  <label className="form-label fw-semibold text-secondary">
                    Message
                  </label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    className="form-control form-control-lg fs-6"
                    rows="3"
                    required
                  ></textarea>
                </div>

                {error && (
                  <div className="alert alert-danger py-2">{error}</div>
                )}

                <button
                  type="submit"
                  disabled={submitting}
                  className="btn w-100 text-white fw-bold py-3 fs-5 d-flex align-items-center justify-content-center gap-2"
                  style={{ backgroundColor: "#b800ff" }}
                >
                  <span>{submitting ? "Sending..." : "Send Message"}</span>
                  <FiSend />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Google Map */}
      <div className="w-100 overflow-hidden mt-4" style={{ lineHeight: 0 }}>
        <iframe
          title="Google Map"
          src={mapSrc}
          width="100%"
          height="400"
          style={{ border: 0 }}
          loading="lazy"
        ></iframe>
      </div>

      {/* Modal - Customized with Bootstrap Popup Overlay */}
      {isSubmitted && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50"
          style={{ zIndex: 1050 }}
        >
          <div
            className="bg-white p-4 rounded-3 text-center position-relative shadow-lg"
            style={{ width: "90%", maxWidth: "400px" }}
          >
            <button
              className="btn position-absolute top-0 end-0 m-2 text-muted border-0"
              onClick={closeModal}
            >
              <FaTimes className="fs-5" />
            </button>
            <FaCheckCircle className="text-success display-3 mb-3" />
            <h3 className="fw-bold text-dark">Message Sent!</h3>
            <p className="text-muted">Thank you for contacting us.</p>
            <button
              className="btn btn-success px-4 py-2 mt-2"
              onClick={closeModal}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactUs;
